<template>
  <router-view />
</template>

<script>
export default {
  name: 'Admin.Dashboard'
}
</script>

<style scoped>

</style>
